import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

type FormField = {
  id: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  maxlength?: number;
  type: 'text' | 'select' | 'group' | 'label' | 'RefImages' | 'instruction' | 'accountNumber';
  options?: any[];
  errorMessage?: string;
  fields?: FormField[];
  className?: string
};

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['../add-edit-payment-method.component.css']
})

export class Bank {
  @Input() ban: any;
  @Input() paymentMethodData: any;
  @Input() apiResponseError: any;

  @Output() updatePaymentMethod = new EventEmitter<any>();
  @Output() addPaymentMethod = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();

  public paymentFormBank: FormGroup;
  paymentMethodOptions: any = [{ value: 'CHECKING', label: 'Checking' }, { value: 'SAVINGS', label: 'Savings' }]
  stateOptions: any = [
    { value: 'AL', label: 'AL' },
    { value: 'AK', label: 'AK' },
    { value: 'AZ', label: 'AZ' },
    { value: 'AR', label: 'AR' },
    { value: 'CA', label: 'CA' },
    { value: 'CO', label: 'CO' },
    { value: 'CT', label: 'CT' },
    { value: 'DE', label: 'DE' },
    { value: 'FL', label: 'FL' },
    { value: 'GA', label: 'GA' },
    { value: 'HI', label: 'HI' },
    { value: 'ID', label: 'ID' },
    { value: 'IL', label: 'IL' },
    { value: 'IN', label: 'IN' },
    { value: 'IA', label: 'IA' },
    { value: 'KS', label: 'KS' },
    { value: 'KY', label: 'KY' },
    { value: 'LA', label: 'LA' },
    { value: 'ME', label: 'ME' },
    { value: 'MD', label: 'MD' },
    { value: 'MA', label: 'MA' },
    { value: 'MI', label: 'MI' },
    { value: 'MN', label: 'MN' },
    { value: 'MS', label: 'MS' },
    { value: 'MO', label: 'MO' },
    { value: 'MT', label: 'MT' },
    { value: 'NE', label: 'NE' },
    { value: 'NV', label: 'NV' },
    { value: 'NH', label: 'NH' },
    { value: 'NJ', label: 'NJ' },
    { value: 'NM', label: 'NM' },
    { value: 'NY', label: 'NY' },
    { value: 'NC', label: 'NC' },
    { value: 'ND', label: 'ND' },
    { value: 'OH', label: 'OH' },
    { value: 'OK', label: 'OK' },
    { value: 'OR', label: 'OR' },
    { value: 'PA', label: 'PA' },
    { value: 'RI', label: 'RI' },
    { value: 'SC', label: 'SC' },
    { value: 'SD', label: 'SD' },
    { value: 'TN', label: 'TN' },
    { value: 'TX', label: 'TX' },
    { value: 'UT', label: 'UT' },
    { value: 'VT', label: 'VT' },
    { value: 'VA', label: 'VA' },
    { value: 'WA', label: 'WA' },
    { value: 'WV', label: 'WV' },
    { value: 'WI', label: 'WI' },
    { value: 'WY', label: 'WY' }
  ]

  bankFormFields: FormField[] = [
    {
      id: 'rountingNumber',
      label: 'Rounting Number',
      placeholder: 'Enter rounting number',
      required: true,
      maxlength: 9,
      errorMessage: 'Invalid rounting number. It should be 9 digits.',
      type: 'text',
    },
    {
      id: 'paymentMethodType',
      label: 'Payment Method',
      required: true,
      options: this.paymentMethodOptions,
      type: 'select',
      errorMessage: 'Invalid payment method type.',
    },
    {
      id: 'accountInfo',
      label: 'Account Information',
      type: 'label',
      className: 'boldLabel'
    },
    {
      id: 'accountNumber',
      label: 'Account Number',
      placeholder: 'Enter the account number',
      required: true,
      maxlength: 20,
      errorMessage: 'Invalid account number.',
      type: 'accountNumber'
    },
    {
      id: 'nameOnAccount',
      label: 'Name On Account',
      placeholder: 'Enter name',
      required: true,
      errorMessage: 'Invalid name on account.',
      type: 'text'
    },
    {
      id: 'zipCode',
      label: 'ZIP code',
      placeholder: 'Enter ZIP code',
      required: true,
      maxlength: 5,
      errorMessage: 'Invalid ZIP code.',
      type: 'text'
    }
  ];

  constructor(private formBuilder: FormBuilder, private http: HttpClient) {

    this.paymentFormBank = this.formBuilder.group({
      id: [''],
      paymentMethodType: ['', Validators.required],
      rountingNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{9}$/) // Exactly 9 digits
        ]
      ],
      nameOnAccount: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z ]+$') // Only letters and spaces allowed
        ]
      ],
      accountNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(20),
          Validators.pattern('^[0-9]+$') // Only digits allowed
        ]
      ],
      streetAddress: [
        '',
        [
          Validators.minLength(5),
          Validators.maxLength(100)
        ]
      ],
      city: [
        '',
        [
          Validators.pattern('^[a-zA-Z ]+$') // Only letters and spaces allowed
        ]
      ],
      state: [
        '',
        [
          Validators.pattern('^[A-Z]{2}$') // Exactly 2 uppercase letters (for state code)
        ]
      ],
      zipCode: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{5}(-[0-9]{4})?$') // 5 digits, optionally followed by a hyphen and 4 more digits
        ]
      ]
    });
  }

  get paymentMethodDetails() {
    return this.paymentMethodData;
  }

  ngOnInit() {
    const accountNumberControl = this.paymentFormBank.get('accountNumber');
    if (this.paymentMethodData.id) {
      this.patchFormValues(this.paymentMethodDetails)
      accountNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
        Validators.pattern('^[0-9*]+$')
      ]);
    } else {
      accountNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
        Validators.pattern('^[0-9]+$')
      ]);
    }
  }

  patchFormValues(data: any) {
    if (data.paymentType == 'ACH') {
      this.paymentFormBank.patchValue({
        id: data.id,
        paymentMethodType: data.type,
        rountingNumber: data.aba,
        nameOnAccount: data.accountHolderInfo.accountHolderName,
        accountNumber: this.formatAccountNumber(data.truncatedDda),
        // jointName: data.jointName,
        // paymentNickname: data.paymentNickname,
        // streetAddress: data.streetAddress,
        // city: data.city,
        // state: data.state,
        zipCode: data.zipCode
      });
    }
  }

  getBankFormField(field: any) {
    return this.paymentFormBank.get(field);
  }

  getBankErrorCheck(field: any) {
    return (this.getBankFormField(field)?.invalid && (this.getBankFormField(field)?.touched || this.getBankFormField(field)?.dirty))
  }

  get isAccountNumberUpdated(): boolean {
    const editedAccountNumber = this.paymentFormBank.value.accountNumber;
    const receivedAccountNumber = this.paymentMethodDetails.truncatedDda;
    if (!editedAccountNumber || !receivedAccountNumber) {
      return true;
    }
    return editedAccountNumber.replace(/\*/g, '') !== receivedAccountNumber.replace(/\*/g, '');
  }

  async onSubmitBank() {
    if (this.paymentFormBank.valid) {
      let formData = {
        "id": this.paymentFormBank.value.id,
        "paymentType": "ACH",
        "rountingNumber": this.paymentFormBank.value.rountingNumber,
        "cardHolderName": this.paymentFormBank.value.nameOnAccount,
        "bankAccountNumber": this.isAccountNumberUpdated ? this.paymentFormBank.value.accountNumber : '',
        "creditAccount": this.ban,
        "paymentMethodKind": this.paymentFormBank.value.paymentMethodType,
        // jointName: data.jointName,
        // paymentNickname: data.paymentNickname,
        // "street": this.paymentFormBank.value.streetAddress,
        // "city": this.paymentFormBank.value.city,
        // "state": this.paymentFormBank.value.state,
        "zip": this.paymentFormBank.value.zipCode
      }
      if (this.paymentMethodData.id) {
        this.updatePaymentMethod.emit(formData)
      }
      else {
        this.addPaymentMethod.emit(formData)
      }
    } else if (this.paymentFormBank.invalid) {
      this.paymentFormBank.markAllAsTouched();
    }
  }

  selectDropdownValue(field: any, e: any) {
    this.paymentFormBank.get(field)!.setValue(e.label);
  }

  clearForm() {
    this.paymentFormBank.reset();
  }

  closePopup() {
    this.closeModal.emit();
  }

  onAccountNumberInput(event: any): void {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/\D/g, '');
    this.paymentFormBank.get('accountNumber')?.setValue(sanitizedValue, { emitEvent: false });
  }

  formatAccountNumber(input: any) {
    const formattedInput = input.slice(-4);
    return '*****' + formattedInput;
  }
}
